<template>
  <div>
    <Tabs :animated="false" type="card">
      <TabPane label="解约信息" name="0">
        <termination-info @showimg="showImg" :infoData="infoData"></termination-info>
      </TabPane>
      <TabPane label="交割信息" name="1">
        <delivery @showimg="showImg" :deliverysInfo="deliverysInfo"></delivery>
      </TabPane>
      <TabPane label="结算信息" name="2">
        <balance-info :balanceInfo="balanceInfo" :contractCode="contractCode" :surrenderFid="surrenderFid" v-if="surrenderFid"></balance-info>
      </TabPane>
      <div slot="extra">
        <!--      <a style="padding: 8px 16px 16px;" target="_blank" v-if="infoData && infoData.protocolUrl" :href="infoData.protocolUrl">解约协议文本查看</a>-->
        <a href="javascript:void(0)" class="mr20" @click.stop="getSignedText('busId')">解约协议</a>
        <a href="javascript:void(0)" class="mr20" v-if="infoData && infoData.surMode==1" @click.stop="getSignedText('balanceBusId')">解约结算单</a>

        <a href="javascript:void(0)" class="mr20" @click.stop="pN++" v-if="voucherListNum">查看凭证</a>


        <z-upload
          action="/file/uploadFile"
          @uploadSuccess="uploadSuccess"
          :format="['gif','jpg','jpeg','png','GIF','JPG','PNG']"
        >
          <a href="javascript:;" class="tab-right">上传凭证</a>
        </z-upload>

        <!--      <z-upload-->
        <!--        v-if="isaudit !==1 "-->
        <!--        action="/surrender/uploadVoucher"-->
        <!--        :data="getData"-->
        <!--        @uploadSuccess="uploadSuccess">-->
        <!--        <a href="javascript:;"  class="tab-right" v-p="{menu:'contractlist',api:'contract/uploadSupplyProtocol'}">上传</a>-->
        <!--      </z-upload>-->

      </div>
    </Tabs>
    <div class="audit-btn-wrap" v-if="isAudit">
      <Button type="primary" size="large" @click="pass">通过</Button>
      <Button type="primary" size="large" @click="dismissed">驳回</Button>
    </div>
    <img-show :n="showImgKey" :src="imgSrc"></img-show>
    <dismissed-modal :n="dismissedKey" :surrenderFid="surrenderFid" @closeTag="closeTag"></dismissed-modal>
    <protocol-list :n="pN" :fid="surrenderFid" ref="vlist" @num="setNum"></protocol-list>
  </div>
</template>

<script type="text/ecmascript-6">
  import {
    getSurrenderInfo,
    getSurrenderDeliverys,
    getSurrenderCostItem,
    confirmSurrAudit,
    getSignedText
  } from 'api/termination'
  import TerminationInfo from './components/TerminationInfo'
  import Delivery from './../../components/PersonalDeliveryInfo'
  import ImgShow from 'components/ImgShow/index'
  import BalanceInfo from './components/BalanceInfo'
  import DismissedModal from './../components/DismissedModal'
  import ZUpload from '@/components/upload/index';
  import {uploadVoucher, getVouchers} from "../../../../api/contractList";
  import ProtocolList from './components/ProtocolList'

  export default {
    name: 'personalcontractdetail1',
    created() {
      this.surrenderFid = this.$route.query.surrenderFid
      this.contractFid = this.$route.query.contractFid
      this.isAudit = this.$route.query.isAudit
      this.initData()
    },
    // activated(){
    //   if(this.isActive){
    //     this.surrenderFid = this.$route.query.surrenderFid
    //     this.contractFid = this.$route.query.contractFid
    //     this.isAudit = this.$route.query.isAudit
    //     this.initData()
    //   }else{
    //     this.isActive = true
    //   }
    // },
    components: {
      TerminationInfo,
      Delivery,
      BalanceInfo,
      DismissedModal,
      ImgShow,
      ZUpload,
      ProtocolList
    },
    data() {
      return {
        contractCode:'',
        voucherListNum: 0,

        pN: 0,
        isActive: false,
        isAudit: 0,
        surrenderFid: '',
        contractFid: '',
        infoData: null,
        deliverysInfo: null,
        balanceInfo: null,
        showImgKey: 0,
        dismissedKey: 0,
        imgSrc: ''
      };
    },
    computed: {
      num() {
        return this.$refs['vlist'].data.length

      },
      tag() {
        return this.$store.state.tagsView.visitedViews.find(tag => {
          return tag.path === this.$route.path
        });
      }
    },
    methods: {
      setNum(num) {
        this.voucherListNum = num

      },
      getSignedText(p) {
        if (!this.infoData[p]) {
          this.$Message.info('暂无' + (p === 'busId' ? '解约协议' : '解约结算单'))
          return
        }
        let params = {
          contractFid: this.contractFid,
          busId: this.infoData[p]
        }
        getSignedText(params).then(res => {
          if (!res.data ) {
            this.$Message.info('电子签章正在下载，请稍后刷新页面或返回重试')
            return
          }

          if(p==='balanceBusId'){
            let url=this.infoData.isAutoConfirm===0?res.data.signPdfUrlForHttp:res.data.pdfUrlForHttps
             window.open(url, '_blank')
          }
          else {
            window.open(res.data.signPdfUrlForHttp, '_blank')

          }

          // console.log(res)

        }).catch(error => {
        })

      },
      noPro() {
      this.$Message.info('电子签章正在下载，请稍后刷新页面或返回重试')
      },
      uploadSuccess(res, file) {
        // console.log(res)
        console.log('----')
        console.log(file)
        if (!res.data) {
          return
        }
        let params = {
          fid: res.data.fid,
          attachmentImgUrl: res.data.url,
          moduleFid: this.surrenderFid,
          attachmentName: file.name

        }
        uploadVoucher(params).then(() => {
          this.$Message.success('上传成功')
          this.$refs['vlist'].getVouchers()

        }).catch(error => {
        })

      },
      showImg(data) {
        this.imgSrc = data
        this.showImgKey++
      },
      // getInfo(name){
      //   if(name==0) {
      //     this.getBasic()
      //   } else if(name==1){
      //      this.getDeliverysInfo()
      //   }else {
      //      this.getSurrenderCostItem()
      //   }
      // },
      initData() {
        this.getBasic()
        this.getDeliverysInfo()
        this.getSurrenderCostItem()
      },
      getBasic() {
        if (this.surrenderFid) {
          getSurrenderInfo(this.surrenderFid).then(res => {
            console.log(res.data,'infooooo')
            this.infoData = res.data
            this.contractCode = this.infoData.contractCode
          })
        }
      },
      getDeliverysInfo() {
        let params = {
          surrenderFid: this.surrenderFid,
          contractFid: this.contractFid
        }
        getSurrenderDeliverys(params).then(res => {
          this.deliverysInfo = res.data
        })
      },
      getSurrenderCostItem() {
        let params = {
          surrenderFid: this.surrenderFid,
          contractFid: this.contractFid
        }
        getSurrenderCostItem(params).then(res => {
          this.balanceInfo = res.data
        })
      },
      pass() {
        let data = {
          auditType: 1,
          surrenderFid: this.surrenderFid
        }
        confirmSurrAudit(data).then(res => {
          this.$Message.success('审核通过!');
          this.closeTag()
        })
      },
      dismissed() {
        this.dismissedKey++
        //console.log('dismissed')
      },
      closeTag() {
        this.$router.push({name:'order',params:{targetTab:'4'}})

      }
    }
  }
</script>
